import React, { useEffect, useRef, useState } from "react";
import Formsy from "formsy-react";
import { TextFieldFormsy } from "@fuse";
import { Button, InputAdornment, Icon } from "@material-ui/core";
import * as authActions from "app/auth/store/actions";
import { useDispatch, useSelector } from "react-redux";

function JWTRegisterTab(props) {
  const dispatch = useDispatch();
  const register = useSelector(({ auth }) => auth.register);

  const [isFormValid, setIsFormValid] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (
      register.error &&
      (register.error.username || register.error.password || register.error.email)
    ) {
      formRef.current.updateInputsWithError({
        ...register.error,
      });
      disableButton();
    }
  }, [register.error]);

  function disableButton() {
    setIsFormValid(false);
  }

  function enableButton() {
    setIsFormValid(true);
  }

  function handleSubmit(model) {
    dispatch(authActions.submitRegister(model));
  }

  return (
    <div className="w-full">
      <Formsy
        onValidSubmit={handleSubmit}
        onValid={enableButton}
        onInvalid={disableButton}
        ref={formRef}
        className="flex flex-col justify-center w-full"
      >
        <TextFieldFormsy
          className="mb-16"
          type="text"
          name="displayName"
          label="Nom de famille"
          validations={{
            minLength: 4,
          }}
          validationErrors={{
            minLength: "La longueur minimale des caractères est de 4",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Icon className="text-20" color="action">
                  person
                </Icon>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required
        />

        <TextFieldFormsy
          className="mb-16"
          type="text"
          name="email"
          label="Email"
          validations="isEmail"
          validationErrors={{
            isEmail: "Doit etre une adresse email valide",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Icon className="text-20" color="action">
                  email
                </Icon>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required
        />

        <TextFieldFormsy
          className="mb-16"
          type="password"
          name="password"
          label="Mot de passe"
          validations="equalsField:password-confirm"
          validationErrors={{
            equalsField: "Les mots de passe ne correspondent pas",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Icon className="text-20" color="action">
                  vpn_key
                </Icon>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required
        />

        <TextFieldFormsy
          className="mb-16"
          type="password"
          name="password-confirm"
          label="Confirmez le mot de passe"
          validations="equalsField:password"
          validationErrors={{
            equalsField: "Les mots de passe ne correspondent pas",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Icon className="text-20" color="action">
                  vpn_key
                </Icon>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="w-full mx-auto mt-16 normal-case"
          aria-label="REGISTER"
          disabled={!isFormValid}
          value="legacy"
        >
          S'inscrire
        </Button>
      </Formsy>
    </div>
  );
}

export default JWTRegisterTab;
